var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypalCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "175%",
    height: "175%",
    x: "-37.5%",
    y: "-37.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.231372549 0 0 0 0 0.454901961 0 0 0 0 0.658823529 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263B80",
    d: "M21.135 9.255c-.678-.787-1.937-1.181-3.68-1.181h-4.84c-.291 0-.582.295-.678.59L10 21.565c0 .294.194.491.387.491h3.002l.774-4.824v.197c.097-.296.388-.591.678-.591h1.453c2.808 0 4.938-1.182 5.616-4.43v-.296c-.097 0-.097 0 0 0 .096-1.28-.097-2.068-.775-2.856"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#139AD6",
    d: "M21.813 12.11v.296c-.678 3.348-2.808 4.43-5.616 4.43h-1.453c-.29 0-.58.296-.677.592l-.969 6.006c0 .197.097.394.388.394h2.517c.29 0 .581-.197.581-.493v-.098l.484-3.052v-.197c0-.296.29-.493.581-.493h.388c2.42 0 4.357-.984 4.84-3.938.194-1.182.098-2.265-.483-2.954a.996.996 0 0 0-.581-.492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232C65",
    d: "M21.135 11.815c-.097 0-.194-.098-.29-.098-.097 0-.194 0-.291-.099-.387-.098-.775-.098-1.259-.098H15.52c-.097 0-.194 0-.29.098a.543.543 0 0 0-.29.493l-.776 5.12v.197c.097-.296.388-.591.678-.591h1.453c2.808 0 4.938-1.182 5.616-4.43 0-.1 0-.198.096-.296-.193-.099-.29-.197-.484-.197-.29-.099-.29-.099-.387-.099"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalCircle);
export default __webpack_public_path__ + "static/media/paypal-circle.87f2e8e348120a68e26087faae05fcb0.svg";
export { ForwardRef as ReactComponent };